import { Injectable } from "@angular/core";
import { SearchTypeModel } from "src/app/Models/AttachmentInfo.model";

@Injectable({
  providedIn: "root",
})
export class SearchPageService {
  searchTerm: string;
  ictSearchTerm: string;
  searchOptions = new SearchTypeModel();
  filterButtonFlag = false;

  constructor() {
    this.ictSearchTerm = "";
    this.searchTerm = "";
  }
}
